if (!customElements.get('grs-editorial')) {
 customElements.define('grs-editorial', class extends HTMLElement {
  connectedCallback() {
   if (this.dataset.ready) return;
   this.dataset.ready = 'true';
   const prose = this.querySelector('[data-grs-prose]');
   if (!prose) return;
   const firstHeading = prose.firstElementChild;
   if (firstHeading?.matches('h2') && firstHeading.textContent.trim() === this.dataset.title?.trim()) firstHeading.remove();
   const headings = [...prose.querySelectorAll('h2')].filter(heading => heading.textContent.trim());
   const toc = this.querySelector('[data-grs-toc]');
   if (headings.length > 1) {
    this.querySelector('.grs-reading-nav').hidden = false;
    headings.forEach((heading, index) => {
     if (!heading.id) heading.id = 'grs-reading-section-' + (index + 1);
     const link = document.createElement('a');
     link.href = '#' + heading.id;
     link.textContent = heading.textContent;
     toc.append(link);
    });
   } else this.classList.add('grs-reading-layout--simple');
   this.querySelectorAll('template[data-grs-figure]').forEach((template, index) => {
    const target = headings[2 + index * 3];
    if (target) target.before(template.content.cloneNode(true));
   });
   prose.querySelectorAll('table').forEach(table => {
    if (table.parentElement.classList.contains('grs-table-scroll')) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'grs-table-scroll';
    wrapper.tabIndex = 0;
    wrapper.setAttribute('role', 'region');
    wrapper.setAttribute('aria-label', table.caption?.textContent || this.dataset.tableLabel);
    table.before(wrapper); wrapper.append(table);
   });
  }
 });
}
document.addEventListener('change', event => {
 if (event.target.matches('[data-grs-sort]')) event.target.form.requestSubmit();
});

// Keep the full cart's empty state in sync with native AJAX line removal.
document.addEventListener('DOMContentLoaded', () => {
 const cartForm = document.querySelector('.template-cart .frm_cart_page');
 const cartItems = cartForm?.querySelector('.cart_items');
 const emptyCart = document.querySelector('.template-cart .empty_cart_page');
 if (!cartForm || !cartItems || !emptyCart) return;
 const syncEmptyCart = () => {
  const hasItems = Boolean(cartItems.querySelector('.cart_item'));
  cartForm.classList.toggle('dn', !hasItems);
  emptyCart.classList.toggle('dn', hasItems);
 };
 new MutationObserver(syncEmptyCart).observe(cartItems, { childList: true, subtree: true });
 syncEmptyCart();
}, { once: true });


// Preserve the native swatch selection handler while supporting keyboard activation.
document.addEventListener('keydown', event => {
 const swatch = event.target.closest('.swatch_pr_item[role="button"]');
 if (swatch && (event.key === 'Enter' || event.key === ' ')) {
  event.preventDefault();
  swatch.click();
 }
});
document.addEventListener('click', event => {
 const swatch = event.target.closest('.swatch_pr_item[role="button"]');
 if (!swatch) return;
 requestAnimationFrame(() => {
  swatch.closest('.swatch__list_pr')?.querySelectorAll('.swatch_pr_item').forEach(option => {
   option.setAttribute('aria-pressed', String(option.classList.contains('is-selected') || option.classList.contains('is-selected-cs')));
  });
 });
}, true);

// Shopify policy content may contain legacy H1 section headings. Keep the page title unique.
document.querySelectorAll('.shopify-policy__body h1').forEach(heading => {
 const subheading = document.createElement('h2');
 [...heading.attributes].forEach(attribute => subheading.setAttribute(attribute.name, attribute.value));
 subheading.innerHTML = heading.innerHTML;
 heading.replaceWith(subheading);
});
